module.exports = __webpack_public_path__ + "3b0871dee385d2f970ed395d5dda0b73.pdf";